module.exports = __webpack_public_path__ + "img/fh_slider5.79cca33e.jpg";